import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

export const fetchCourseOutline = async (courseId) => {
    let url = `${getConfig().LMS_BASE_URL}/api/learning_sequences/v1/course_outline/${courseId}`;
    const { data } = await getAuthenticatedHttpClient().get(url);
    return data;
};